const loadingKeys = {
  fetchCustomerCounter: 'fetchCustomerCounter',
  reloadSaleItemsCounter: 'reloadSaleItemsCounter'
}

const getInitialState = () => ({
  payBoxLoadings: {
    [loadingKeys.fetchCustomerCounter]: 0,
    [loadingKeys.reloadSaleItemsCounter]: 0
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getIsCustomerFetching(state) {
      return state.payBoxLoadings[loadingKeys.fetchCustomerCounter] > 0
    },

    getIsSaleItemsReloading(state) {
      return state.payBoxLoadings[loadingKeys.reloadSaleItemsCounter] > 0
    },
  },

  mutations: {
    INCREMENT_LOADING_COUNTER(state, { loadingName }) {
      state.payBoxLoadings[loadingName] += 1
    },
    DECREMENT_LOADING_COUNTER(state, { loadingName }) {
      if (state.payBoxLoadings[loadingName] > 0) {
        state.payBoxLoadings[loadingName] -= 1
      }
    },

    CLEAN_STATE(state) {
      const defaultData = getInitialState()
      Object.keys(defaultData).forEach(key => {
        state[key] = defaultData[key]
      })
    },
  },

  actions: {
    async setStartFetchCustomer({ commit }) {
      commit('INCREMENT_LOADING_COUNTER', { loadingName: loadingKeys.fetchCustomerCounter })
    },
    async setFinishFetchCustomer({ commit }) {
      commit('DECREMENT_LOADING_COUNTER', { loadingName: loadingKeys.fetchCustomerCounter })
    },

    async setStartSaleItemsReloadPrice({ commit }) {
      commit('INCREMENT_LOADING_COUNTER', { loadingName: loadingKeys.reloadSaleItemsCounter })
    },
    async setFinishSaleItemsReloadPrice({ commit }) {
      commit('DECREMENT_LOADING_COUNTER', { loadingName: loadingKeys.reloadSaleItemsCounter })
    },

    cleanPayBoxStatusState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
